const UserIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none'>
      <path
        d='M15.75 6.58723C15.75 7.5818 15.3549 8.53562 14.6517 9.23888C13.9484 9.94215 12.9946 10.3372 12 10.3372C11.0054 10.3372 10.0516 9.94215 9.34836 9.23888C8.6451 8.53562 8.25001 7.5818 8.25001 6.58723C8.25001 5.59267 8.6451 4.63885 9.34836 3.93558C10.0516 3.23232 11.0054 2.83723 12 2.83723C12.9946 2.83723 13.9484 3.23232 14.6517 3.93558C15.3549 4.63885 15.75 5.59267 15.75 6.58723ZM4.50101 20.7052C4.53314 18.7376 5.33735 16.8614 6.74018 15.4813C8.14302 14.1012 10.0321 13.3277 12 13.3277C13.9679 13.3277 15.857 14.1012 17.2598 15.4813C18.6627 16.8614 19.4669 18.7376 19.499 20.7052C17.1464 21.784 14.5882 22.3407 12 22.3372C9.32401 22.3372 6.78401 21.7532 4.50101 20.7052Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default UserIcon;
